<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Wallet"></app-breadcrumb>

        <!-- money -->
        <div class="row">
            <div class="col-12">
                <h3 class="md-small-text">Shop's Available Cash</h3>
                <div class="card mt-2 bg-light p-5">
                    <div class="c1 p-4"></div>
                    <div class="c2 p-4"></div>
                    <h1 class="wallet-cash text-center display-2 p-5 text-uppercase">
                        {{user.currency}} {{myWallet.profit | money}}
                    </h1>
                    <div class="c3 p-4"></div>
                    <div class="c4 p-4"></div>
                </div>
            </div>
        </div>
        <!-- statement -->
        <div v-if="myWallet" class="row mt-5">
            <div class="col-12 mt-3">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <tbody>
                            <tr v-for="(statement, i) in myWallet.statements.slice(0, 3)" :key="i">
                                <td>
                                    {{i+1}}. 
                                    <span v-if="statement.profit">You sold {{statement.title}} </span> 
                                    <span v-else>You bought {{statement.title}} </span> 
                                    <span v-if="statement.profit" class="text-dark-green text-uppercase">{{statement.currency}} {{statement.price | money}}</span> 
                                    <span v-else class="text-danger text-uppercase">{{statement.currency}} {{statement.price | money}}</span> 
                                    {{statement.soldTime | moment("MMM D 'YY hh:mm A")}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <router-link :to="{ name: 'statement' }">
                                        <i class="fas fa-long-arrow-alt-down"></i> 
                                        <strong class="mx-2">see more statements</strong> 
                                        <i class="fas fa-long-arrow-alt-down"></i>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Wallet",
    methods: {
        ...mapActions(['fetchWallet']),
    },
    computed: {
        ...mapGetters(['user', 'wallet']),
        myWallet() {
            if(this.wallet && this.wallet !== null){
                return this.wallet
            }
            return false
        },
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchWallet().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>